<template>
  <div class="settings-page" :class="{ 'settings-page--mobile': !isPC }">
    <header class="settings-header">
      <button type="button" class="back-btn" @click="handleBack">
        <SvgIcon name="settings-nav-back" :size="12" />
        <span>返回</span>
      </button>

      <nav class="settings-tabs" aria-label="账号设置">
        <router-link
          v-for="item in tabItems"
          :key="item.name"
          :to="{ name: item.name }"
          class="settings-tab"
          :class="{ active: route.name === item.name }"
        >
          <span class="settings-tab-label">{{ item.label }}</span>
          <span class="settings-tab-indicator" aria-hidden="true" />
        </router-link>
      </nav>
    </header>

    <div class="settings-body">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useRoute, useRouter } from 'vue-router';
  import SvgIcon from '@/components/common/icon/SvgIcon.vue';
  import { useViewportAccessGate } from '@/hooks/useViewportAccessGate';

  const route = useRoute();
  const router = useRouter();
  const { isPC } = useViewportAccessGate();

  const tabItems = [
    { name: 'settings-profile', label: '个人信息' },
    { name: 'settings-account', label: '账号管理' }
  ];
  function handleBack() {
    router.push({ name: 'create' });
  }
</script>

<style scoped>
  .settings-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  .settings-header {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding: 25px 0 0 25px;
    box-sizing: border-box;
  }

  .back-btn {
    position: fixed;
    top: 44px;
    left: calc(
      var(--workspace-sidebar-offset) + var(--workspace-sidebar-width) +
        var(--workspace-content-gap) + 25px
    );
    z-index: 2;
    width: fit-content;
    height: 36px;
    padding: 0 16px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 1px solid #eff0f7;
    border-radius: 66px;
    background: #ffffff;
    color: #160211;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    cursor: pointer;
    transition:
      border-color 0.15s,
      color 0.15s;
  }

  .back-btn:hover {
    border-color: #d8d9e6;
    color: #6033e1;
  }

  .settings-tabs {
    height: 32px;
    margin-left: 7px;
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  .settings-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-width: 56px;
    color: #6e6a7c;
    font-size: 14px;
    line-height: 22px;
    text-decoration: none;
    transition: color 0.15s;
  }

  .settings-tab:hover {
    color: #160211;
  }

  .settings-tab.active {
    color: #160211;
  }

  .settings-tab-label {
    line-height: 14px;
  }

  .settings-tab-indicator {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background: #6033e1;
    opacity: 0;
    transition: opacity 0.15s;
  }

  .settings-tab.active .settings-tab-indicator {
    opacity: 1;
  }

  .settings-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 29px 0 40px 32px;
    box-sizing: border-box;
  }

  .settings-page--mobile {
    background: #fbf9ff;
  }

  .settings-page--mobile .settings-header {
    gap: 0;
    padding: 17px 16px 0;
  }

  .settings-page--mobile .back-btn {
    display: none;
  }

  .settings-page--mobile .settings-tabs {
    height: 32px;
    gap: 20px;
    margin-left: 0;
  }

  .settings-page--mobile .settings-tab {
    gap: 8px;
    min-width: 56px;
  }

  .settings-page--mobile .settings-body {
    padding: 8px 16px 15px;
  }
</style>
